//Permanent
const twitterAccount = "elcomercio_peru";    
const urlBrand = "https://elcomercio.pe/";
const urlPortadaEspeciales = "https://especiales.elcomercio.pe/?q=especiales/especiales-el-comercio/index.html";
const domainMarca = "https://especiales.elcomercio.pe/?q=especiales/";
const domainAssets = 'https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_prod/especiales/';
const urlCommonAssets = `${domainAssets}elementos-comunes-2`;

//Variable
const socialShareText = "Deportistas Antivacunas | El Comercio";
const slugEspecial = "deportistas-antivacunas-covid-19-multimedia-nndd";
const urlEspecial = `${domainMarca}${slugEspecial}/index.html`;
const urlAssets = `${domainAssets}${slugEspecial}`;
//const urlJson = 'http://localhost:81/especiales/deportistas-antivacunas-covid-19-multimedia-nndd/json/photogallery.json';
const urlJson = `${domainAssets}${slugEspecial}/json/photogallery.json`;
const queryStringText = 'deportista';

export { 
    queryStringText,
    twitterAccount, 
    urlBrand, 
    urlPortadaEspeciales, 
    domainMarca, 
    domainAssets, 
    urlCommonAssets, 
    socialShareText, 
    slugEspecial, 
    urlEspecial, 
    urlAssets, 
    urlJson 
}